var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#172664"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7222 29.3889C25.7222 29.9488 25.5349 30.4858 25.2015 30.8817C24.8681 31.2776 24.4159 31.5 23.9444 31.5H15.0555C14.584 31.5 14.1318 31.2776 13.7984 30.8817C13.465 30.4858 13.2777 29.9488 13.2777 29.3889V18.8333C13.2777 18.2734 13.465 17.7365 13.7984 17.3406C14.1318 16.9446 14.584 16.7222 15.0555 16.7222H23.9444C24.4159 16.7222 24.8681 16.9446 25.2015 17.3406C25.5349 17.7365 25.7222 18.2734 25.7222 18.8333V29.3889Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2777 16.7228V14.6117C18.2777 14.0518 18.465 13.5148 18.7984 13.1189C19.1318 12.723 19.584 12.5005 20.0555 12.5005H28.9444C29.4159 12.5005 29.8681 12.723 30.2015 13.1189C30.5349 13.5148 30.7222 14.0518 30.7222 14.6117V25.1672C30.7222 25.7271 30.5349 26.2641 30.2015 26.66C29.8681 27.0559 29.4159 27.2783 28.9444 27.2783H26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCopy);
export default __webpack_public_path__ + "static/media/btn_copy.a07632734961c1846b1f1063c2e49be4.svg";
export { ForwardRef as ReactComponent };